import type { CaseIdentity } from './caseIdentity';
import styles from './AlsoKnownAsLine.module.css';

/** The one small "Also known as" line under a header's main identifier
 *  (proposal 6). Renders nothing for a thread with no case. */
export function AlsoKnownAsLine({ identity }: { identity: CaseIdentity }) {
  if (identity.alsoKnownAs.length === 0) return null;
  return (
    <div className={styles.aka} data-testid="also-known-as">
      Also known as:{' '}
      {identity.alsoKnownAs.map((a, i) => (
        <span key={a.kind}>
          {i > 0 && ' · '}
          {a.lead}{' '}
          {a.ref ? <b>{a.ref}</b> : <i>{a.tail}</i>}
          {a.ref && a.tail ? ` ${a.tail}` : ''}
        </span>
      ))}
    </div>
  );
}
